import { render, staticRenderFns } from "./SelectMultipleCustomerGroups.vue?vue&type=template&id=fb25d5c0&"
import script from "./SelectMultipleCustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleCustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports